

export const AVAILABLE_TRANSLATIONS = [
  {
    id: 20,
    lang: 'en',
    name: 'Saheeh International',
    nativeName: 'English',
    author: 'Saheeh International',
    direction: 'ltr',
    popular: true
  },
  {
    id: 45,
    lang: 'ru',
    name: 'Elmir Kuliev',
    nativeName: 'Русский',
    author: 'Эльмир Кулиев',
    direction: 'ltr',
    popular: true
  },
  {
    id: 54,
    lang: 'ur',
    name: 'Muhammad Junagarhi',
    nativeName: 'اردو',
    author: 'محمد جوناگڑھی',
    direction: 'rtl',
    popular: true
  },
  {
    id: 161,
    lang: 'bn',
    name: 'Taisirul Quran',
    nativeName: 'বাংলা',
    author: 'তাইসিরুল কুরআন',
    direction: 'ltr',
    popular: true
  },
  {
    id: 77,
    lang: 'tr',
    name: 'Diyanet İşleri',
    nativeName: 'Türkçe',
    author: 'Diyanet İşleri',
    direction: 'ltr',
    popular: true
  },
  {
    id: 83,
    lang: 'es',
    name: 'Isa Garcia',
    nativeName: 'Español',
    author: 'Isa Garcia',
    direction: 'ltr',
    popular: true
  },
  {
    id: 31,
    lang: 'fr',
    name: 'Muhammad Hamidullah',
    nativeName: 'Français',
    author: 'Muhammad Hamidullah',
    direction: 'ltr',
    popular: true
  },
  {
    id: 25,
    lang: 'bs',
    name: 'Muhamed Mehanović',
    nativeName: 'Bosanski',
    author: 'Muhamed Mehanović',
    direction: 'ltr',
    popular: false
  },
  {
    id: 80,
    lang: 'ml',
    name: 'Karakunnu & Elayavoor',
    nativeName: 'മലയാളം',
    author: 'Karakunnu & Elayavoor',
    direction: 'ltr',
    popular: false
  },
  {
    id: 33,
    lang: 'id',
    name: 'Islamic Affairs Ministry',
    nativeName: 'Bahasa Indonesia',
    author: 'Kementerian Agama',
    direction: 'ltr',
    popular: true
  },
  {
    id: 55,
    lang: 'uz',
    name: 'Muhammad Sodiq (Latin)',
    nativeName: 'O\'zbekcha',
    author: 'Muhammad Sodiq Muhammad Yusuf',
    direction: 'ltr',
    popular: false
  },
  {
    id: 235,
    lang: 'nl',
    name: 'Malak Faris Abdalsalaam',
    nativeName: 'Nederlands',
    author: 'Malak Faris Abdalsalaam',
    direction: 'ltr',
    popular: false
  },
  {
    id: 27,
    lang: 'de',
    name: 'Bubenheim & Nadeem',
    nativeName: 'Deutsch',
    author: 'Frank Bubenheim und Nadeem Elyas',
    direction: 'ltr',
    popular: true
  },
  {
    id: 74,
    lang: 'tg',
    name: 'AbdolMohammad Ayati',
    nativeName: 'Тоҷикӣ',
    author: 'AbdolMohammad Ayati',
    direction: 'ltr',
    popular: false
  },
  {
    id: 50,
    lang: 'ta',
    name: 'Jan Trust Foundation',
    nativeName: 'தமிழ்',
    author: 'Jan Trust Foundation',
    direction: 'ltr',
    popular: false
  },
  {
    id: 35,
    lang: 'ja',
    name: 'Ryoichi Mita',
    nativeName: '日本語',
    author: 'Ryoichi Mita',
    direction: 'ltr',
    popular: false
  },
  {
    id: 153,
    lang: 'it',
    name: 'Hamza Roberto Piccardo',
    nativeName: 'Italiano',
    author: 'Hamza Roberto Piccardo',
    direction: 'ltr',
    popular: false
  },
  {
    id: 220,
    lang: 'vi',
    name: 'Ruwwad Center',
    nativeName: 'Tiếng Việt',
    author: 'Ruwwad Center',
    direction: 'ltr',
    popular: false
  },
  {
    id: 56,
    lang: 'zh',
    name: 'Ma Jian',
    nativeName: '中文',
    author: '马坚',
    direction: 'ltr',
    popular: true
  },
  {
    id: 113,
    lang: 'kk',
    name: 'Khalifah Altai',
    nativeName: 'Қазақша',
    author: 'Khalifah Altai',
    direction: 'ltr',
    popular: false
  },
  {
    id: 53,
    lang: 'tt',
    name: 'Tatar',
    nativeName: 'Татарча',
    author: 'Tatar',
    direction: 'ltr',
    popular: false
  },
  {
    id: 88,
    lang: 'sq',
    name: 'Hasan Efendi Nahi',
    nativeName: 'Shqip',
    author: 'Hasan Efendi Nahi',
    direction: 'ltr',
    popular: false
  }
];


export const POPULAR_TRANSLATIONS = AVAILABLE_TRANSLATIONS.filter(t => t.popular);
export const OTHER_TRANSLATIONS = AVAILABLE_TRANSLATIONS.filter(t => !t.popular);


export function getTranslationById(id) {
  return AVAILABLE_TRANSLATIONS.find(t => t.id === parseInt(id));
}


export function getTranslationByLang(lang) {
  return AVAILABLE_TRANSLATIONS.find(t => t.lang === lang);
}


export function getDefaultTranslations() {
  return [
    getTranslationByLang('en'), 
    getTranslationByLang('ru')  
  ].filter(Boolean);
}
